/* F24 · El latido: una vez por minuto, dónde estás. Solo mientras la pestaña
   está a la vista y hubo teclado o ratón en los últimos dos minutos — una
   pestaña abierta en segundo plano no es trabajo, y decir que sí sería
   inventarse las horas que después se sugieren. Cambiar de pantalla manda un
   latido al momento, para que el tramo empiece donde empezó. */
import { api } from "./api";
import { ruta } from "./router";

let ultimoInput = Date.now();
let temporizador = 0;
let escuchando = false;

const INPUT = ["keydown", "pointerdown", "wheel", "touchstart"] as const;
const activa = () => document.visibilityState === "visible" && Date.now() - ultimoInput < 120e3;

/** De la ruta a lo que se mira: la vista, y si es un job/proyecto/cliente/campaña, cuál. */
function donde() {
  const r = ruta();
  const base = { vista: r.vista, dia: hoyLocal(), desfaseMin: new Date().getTimezoneOffset() };
  const uuid = (s?: string) => !!s && /^[0-9a-f-]{36}$/i.test(s);
  if (r.vista === "jobs" && uuid(r.a)) return { ...base, entidadTipo: "job" as const, entidadId: r.a!, jobId: r.a! };
  if (r.vista === "proyectos" && uuid(r.a)) return { ...base, entidadTipo: "proyecto" as const, entidadId: r.a! };
  if (r.vista === "clientes" && uuid(r.a)) return { ...base, entidadTipo: "cliente" as const, entidadId: r.a! };
  if ((r.vista === "campanas" || r.vista === "medios") && uuid(r.a)) return { ...base, entidadTipo: "campana" as const, entidadId: r.a! };
  // Makai atado a un job cuenta como estar en el job: es trabajo sobre él.
  if (r.vista === "makai" && uuid(r.q.jobId)) return { ...base, entidadTipo: "job" as const, entidadId: r.q.jobId!, jobId: r.q.jobId! };
  return base;
}

function hoyLocal() {
  const d = new Date();
  return d.getFullYear() + "-" + String(d.getMonth() + 1).padStart(2, "0") + "-" + String(d.getDate()).padStart(2, "0");
}

async function latir() {
  if (!activa()) return;
  try { await api.latido(donde()); } catch { /* un latido perdido no importa: el siguiente lo cubre */ }
}

/** Arranca al entrar con sesión; es idempotente. Se para al salir. */
export function arrancarActividad() {
  if (escuchando) return;
  escuchando = true;
  for (const ev of INPUT) window.addEventListener(ev, () => { ultimoInput = Date.now(); }, { passive: true });
  window.addEventListener("hashchange", () => void latir());
  document.addEventListener("visibilitychange", () => { if (document.visibilityState === "visible") { ultimoInput = Date.now(); void latir(); } });
  temporizador = window.setInterval(() => void latir(), 60e3);
  void latir();
}

export function pararActividad() {
  if (temporizador) clearInterval(temporizador);
  temporizador = 0; escuchando = false;
}
